import React, { Component } from "react";
import { Popconfirm, Table, message, Tooltip } from "antd";
import SideNav from '../SideNav';
import "../css/style.less";
import ExportUtil from "../../../common/ExportUtil";
import API_URL from "../../../common/url";
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import Filter from "./Filter";
import Update from "./Update";
import renderEnhancer from "../../shared/renderEnhancer";
import cellRenderEnhancer from "../../shared/cellRenderEnhancer";
import UploadModel from "./UploadModel";

class VisitingHours extends Component {
    state = {
        data: [],
        loading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        businessList: [],
        researchProductTypeList: [],
    }

    componentDidMount() {
        this.loadData();
        this.queryBusiness();
        this.queryConfigWithChildByType();
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { researchProductTypeId = [] } = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryVisitHourList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    };

    //获取业务线选项
    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { list = [] } = res;
            const newList = list.map(el => ({
                value: el.evaluateConfigureId,
                code: el.code,
                label: el.configureValue,
                children: el.childList.length ? el.childList.map(childData => ({
                    value: childData.evaluateConfigureId,
                    label: childData.configureValue,
                })) : undefined,
            }));
            this.setState({ researchProductTypeList: newList });
        });
    }

    search = (searchParams) => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({ 
            pagination, 
            searchParams 
        },() => {
            this.loadData();
        });
    };

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.updatePanes();
        });
    }

    exportData = () => {
        const { searchParams } = this.state;
        const { researchProductTypeId = [] } = searchParams;
        const url = API_URL.evaluate.exportEvaluateVisitHour;
        ExportUtil.export({
            ...searchParams,
            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
        }, null, url);
    }

    downTemplate = () => {
        ExportUtil.export({}, null, API_URL.evaluate.getVisitHourTemp);
        message.success('正在下载中!')
    }

    onUplodChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else {
                const uploadMes = {};
                uploadMes.errorFilePath=file.response.errorFilePath;
                uploadMes.success=file.response.successNum;
                uploadMes.fail=file.response.failNum;
                Number(uploadMes.success) > 0 && this.loadData();
                this.UploadModelRef.show(uploadMes);
            }
        }
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'sortNum',
            key: 'sortNum',
            width: 60,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 60,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病名称',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {diseaseName } = record;
                        const diseaseList = (diseaseName || '').split(',');
                        if ((diseaseList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        diseaseList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0].substring(0,30):'')
            ),
        }, {
            title: '研究产品类型',
            dataIndex: 'researchProductTypeName',
            key: 'researchProductTypeName',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {researchProductTypeName } = record;
                        const researchProductTypeList = (researchProductTypeName || '').split(',');
                        if ((researchProductTypeList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        researchProductTypeList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0].substring(0,30):'')
            ),
        }, {
            title: '访视类别',
            dataIndex: 'visitCategory',
            key: 'visitCategory',
            width: 100,
        }, {
            title: '访视类型',
            dataIndex: 'visitingTypeName',
            key: 'visitingTypeName',
            width: 100,
        }, {
            title: (
                <span>
                    访视工时
                    <Tooltip title="包含和此次访视相关的所有动作，包括且不限于患者沟通，患者访视过程，协助病例书写，化验单整理，数据录入，质疑解答，等等">
                        <span style={{ color: '#1890ff', marginLeft: 4, cursor: 'pointer' }}>ⓘ</span>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'visitHour',
            key: 'visitHour',
            width: 100,
        }, {
            title: '常规备注',
            dataIndex: 'regularRemark',
            key: 'regularRemark',
            width: 150,
        }, {
            title: '疾病特有工作内容',
            dataIndex: 'diseaseSpecificWorkContent',
            key: 'diseaseSpecificWorkContent',
            width: 150,
        }, {
            title: '操作',
            key: 'operation',
            width: 80,
            render: (text, record) => {
                const { evaluateVisitHourId } = record;
                return (
                    <span>
                        <a onClick={() => this.update(record, 'edit')}>修改</a>
                        <span className="ant-divider" />
                        <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.delete(evaluateVisitHourId)} okText="确定" cancelText="取消">
                            <a>删除</a>
                        </Popconfirm>
                    </span>
                );
            },
        }];
        return columns;
    }

    delete = (evaluateVisitHourId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.delVisitHour,
            data: {
                evaluateVisitHourId
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    };

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const dataSource = [];
        data.map((el, index) => {
            dataSource.push({
                ...el,
                sortNum: (pagination.current - 1) * 10 + index + 1,
            });
        });
        return dataSource
    }

    update = (record, key) => {
        this.UpdateRef.show(record, key);
    }

    render() {
        const { loading, pagination, businessList, researchProductTypeList } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="hours"/>
                <div className="main">
                    <Filter
                        search={this.search}
                        exportData={this.exportData}
                        update={this.update}
                        downTemplate={this.downTemplate}
                        onUplodChange={this.onUplodChange}
                        businessList={businessList}
                        researchProductTypeList={researchProductTypeList}
                    />
                    <Table
                        dataSource={this.getDataSource()}
                        bordered
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        scroll={{ x: 500 }}
                    />
                    <Update
                        ref={el => this.UpdateRef = el}
                        businessList={businessList}
                        researchProductTypeList={researchProductTypeList}
                        loadData={this.loadData}
                    />
                    <UploadModel
                        ref={el => this.UploadModelRef = el}
                    />
                </div>
            </div>
        );
    }
}


export default VisitingHours



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitingHours/index.js